{
  "moreNews": "More news"
}
